import React from "react";
import { Typography } from "antd";
import { InputNumberItem, CheckItem, ButtonItem } from "./Items";
import { colorDeSegmento } from "./rutaPickingColores";
import { posicionRackTexto } from "./miniMapaRack";

const { Text } = Typography;

//Tarjeta de una parada de picking: código/nombre, distancia del tramo que lleva ahí, y el checklist de
//insumos a recolectar con su cantidad ajustable. La usan tanto la lista completa del drawer (RutaPicking.js)
//como el panel de "parada actual" dentro de la vista de pantalla completa (VisorRutaPickingMapa.js) - un
//solo lugar para que ambas no se desincronicen.
const TarjetaParadaPicking = ({ parada, segmento, esActual, recolectado, marcar, cambiarCantidad, cantidadEditable = true, accionesInsumo }) => {
  const idParada = parada.ubicacionId || parada.nodoAccesoId;
  const insumos = parada.insumos || [];
  const ubicacionesDeParada = Array.from(new Set(insumos.map((valorInsumo) => valorInsumo.claveUbicacion).filter(Boolean)));

  const marcarTodo = () => {
    insumos.forEach((insumo, indice) => marcar(`${idParada}_${insumo.insumoId}_${indice}`, true));
  };

  return (
    <div
      style={{
        marginBottom: 16,
        border: esActual ? "2px solid #f97316" : "1px solid #f0f0f0",
        borderRadius: 8,
        padding: 12,
        background: esActual ? "#fff7ed" : undefined,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 4 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {segmento && <span style={{ width: 10, height: 10, borderRadius: "50%", background: colorDeSegmento(segmento.numeroSegmento), flexShrink: 0 }} />}
          <div style={{ fontWeight: 700 }}>
            {parada.clave} {parada.nombre ? `- ${parada.nombre}` : ""}
          </div>
        </div>
        {insumos.length > 1 && (
          <ButtonItem lima size="small" onClick={marcarTodo}>
            Marcar todo listo
          </ButtonItem>
        )}
      </div>
      {ubicacionesDeParada.length > 0 && (
        <div style={{ fontSize: 11, color: "#8a93a6", marginBottom: 4 }}>
          Ubicaciones: {ubicacionesDeParada.join(", ")}
        </div>
      )}
      {segmento && (
        <div style={{ fontSize: 11, color: "#8a93a6", marginBottom: 8 }}>
          Tramo {segmento.numeroSegmento} - {segmento.distanciaMetros.toFixed(1)} m desde la parada anterior
        </div>
      )}
      {insumos.map((insumo, indice) => {
        const llave = `${idParada}_${insumo.insumoId}_${indice}`;
        const valor = recolectado[llave] || { checked: false, cantidad: insumo.cantidad };
        return (
          <div key={llave} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <CheckItem checked={valor.checked} onChange={(checked) => marcar(llave, checked)} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <Text style={{ display: "block" }}>
                {insumo.clave} - {insumo.descripcion}
              </Text>
              {posicionRackTexto(insumo) && (
                <Text type="secondary" style={{ fontSize: 11 }}>
                  {posicionRackTexto(insumo)}
                </Text>
              )}
            </div>
            <InputNumberItem
              size="small"
              style={{ width: 90 }}
              min={0}
              max={insumo.cantidad}
              value={valor.cantidad}
              onChange={(value) => cambiarCantidad(llave, value)}
              disabled={!cantidadEditable}
            />
            {accionesInsumo && accionesInsumo(insumo, idParada)}
          </div>
        );
      })}
    </div>
  );
};

export default TarjetaParadaPicking;
